import {
  branch, compose, withPropsOnChange, renderComponent, setPropTypes, setDisplayName,
} from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import get from 'lodash/get'

import { ApiTransport, getApiState, getKeyForQuery } from '@infotech/lib-api-middleware'
import { Spinner } from '@infotech/base-components'

const createWithLazyEntities = ({
  dataSelector,
  schemaName,
  fetchApiAction,
  errorComponent = () => `Нет данных`,
  dataPropName = `entitiesData`,
}) => compose(
  setDisplayName(`WithLazyEntities`),
  setPropTypes({
    query: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect((state, { query }) => {
    const keyForQuery = getKeyForQuery(query)
    return {
      entities: dataSelector(state, keyForQuery),
      apiState: getApiState(state, schemaName, keyForQuery),
    }
  }),
  branch(
    ({ apiState }) => get(apiState, `isFetching`),
    renderComponent(Spinner),
  ),
  branch(
    ({ apiState }) => get(apiState, `hasError`),
    renderComponent(errorComponent),
  ),
  branch(
    ({ apiState }) => apiState,
    withPropsOnChange([`entities`], ({ entities }) => ({
      [dataPropName]: entities,
    })),
    compose(
      withPropsOnChange([`query`], ({ query }) => ({
        entity   : schemaName,
        apiAction: fetchApiAction,
        query,
        dataSelector,
        spinner  : Spinner,
        dataPropName,
      })),
      ApiTransport,
    ),
  ),
)

export default createWithLazyEntities
